export const topBrands = [
  { id: 'Whirlpool_o0pfni.webp', name: 'Whirlpool' },
  { id: 'Voltas_yb5azJT_q3unu6.webp', name: 'Voltas' },
  { id: 'Vivo_gdmcbr.webp', name: 'Vivo' },
  { id: 'vb_fiiit5.webp', name: 'Voltas Beko' },
  { id: 'usha_wqbt4r.webp', name: 'Usha' },
  { id: 'Untitled_design_9_I5DWXza_s8mknw.webp', name: 'Glen' },
  { id: 'Untitled_design_11_tshqil.webp', name: 'Assure' },
  { id: 'TCL_qwsqnm.webp', name: 'Royal' },
  { id: 'Sony_DYh1QKJ_vowvg0.webp', name: 'Bosch' },
  { id: 'Samsung_UJCFAoE_c0gfec.webp', name: 'Carvaan' },
  { id: 'Oppo_ch6qpi.webp', name: 'Oppo' },
  { id: 'pureit-service-center-in-kolkata_bcfupf.webp', name: 'Pureit' },
  { id: 'realme-logo-realme-icon-free-free-vector_xrenh9.jpg', name: 'Sunflame' },
  { id: 'ORIENTELEC.NS_foljpv.webp', name: 'Midea' },
  { id: 'OIP_vpyncv.webp', name: 'Kent' },
  { id: 'Livpure-1_oidezz.webp', name: 'Livpure' },
  { id: 'Ogeneral_p1LqYYd_c4uvao.webp', name: 'HP' },
  { id: 'New-Project_0y7egVX_aeeeb0.webp', name: 'Acer' },
  { id: 'METZ_Logo_-_Copy_150x1502x_azaa3v.webp', name: 'Metz' },
  { id: 'logo_Gd6JLTD_wl0an7.webp', name: 'KAFF' },
  { id: 'logo_2_r2mfza.webp', name: 'Haier' },
  { id: 'Logo_1_tquqnz.webp', name: 'Amstrad' },
  { id: 'logo_1_ewroos.webp', name: 'Avita' },
  { id: 'lloyd_LS8vNJY_yueddb.webp', name: 'Lloyd' },
  { id: 'LG_Fgprtsr_l6m23l.webp', name: 'Symphony' },
  { id: 'LG_4safaVQ_vjtdet.webp', name: 'LG' },
  { id: 'Leneovo_wmbhq3.webp', name: 'Lenovo' },
  { id: 'Hitachi_yy4oye.webp', name: 'Hitachi' },
  { id: 'GVOLHLQ821c7d0fd_786_tdwvbj.webp', name: 'Jaipan' },
  { id: 'googlelogo_color_272x92dp_nym6ya.webp', name: 'Google' },
  { id: 'Eureka-Forbes-Logo_new_updated_msvxcv.webp', name: 'Eureka Forbes' },
  { id: 'download_WYNsrOy_htenmx.webp', name: 'HP' },
  { id: 'download_dBaIGCR_g92imt.webp', name: 'Kent' },
  { id: 'download_8_x5z1ou.webp', name: 'Bajaj' },
  { id: 'download_8_bgeplv.webp', name: 'Panasonic' },
  { id: 'download_6_h7yzlc.webp', name: 'Havells' },
  { id: 'download_5_cwwdy6.webp', name: 'Kenstar' },
  { id: 'download_4_wA7Dcwd_neuszl.webp', name: 'Crompton' },
  { id: 'download_1_xaeo9n.webp', name: 'Midea' },
  { id: 'dell_dsvif8.webp', name: 'Dell' },
  { id: 'Daikin_f8phyo.webp', name: 'Daikin' },
  { id: 'd41fb81a-7c49-4673-9e66-76e9713f3158_ChajykI_oriecn.webp', name: 'Apple' },
  { id: 'carvaanTitleHm_slpmxu.webp', name: 'Carvaan' },
  { id: 'Carrier_spisni.webp', name: 'Carrier' },
  { id: 'bosh_uz2shj.webp', name: 'Bosch' },
  { id: 'bluestar_l6zn5n.webp', name: 'Blue Star' },
  { id: 'Godrejpurple-logo.png', name: 'Godrej' },
  { id: '9b5f8d0d-fbfd-40a9-9e06-9e0a46373d10_fkdlsq.webp', name: 'Nikon' },
  { id: '80a72fa1-815d-4ade-9eef-b06c501f6e4e_hjx3rn.webp', name: 'Morphy Richards' },
  { id: '1_cm1FaBC_cxy5tq.webp', name: 'Brand 1' },
  { id: '1_RJKbm1U_psdvlw.webp', name: 'Brand 2' },
  { id: '1788_a5of0p.jpg', name: 'Brand 3' },
  { id: 'JBL-Logo_opheiw.png', name: 'Brand 3' },
  { id: '41daa1c3869cdc95f624f7bc36fbd3c4.w1668.h1668._CR0016681668_SX200__arjhae.webp', name: 'Brand 4' },
  { id: '7f4052383fb9d22427e992b270a20d21.w400.h400_jYD2IA5_lipsmr.webp', name: 'Brand 5' },
  { id: 'kisspng-laptop-acer-aspire-computer-logo-lenovo-logo-5acb2cceeb7ae4.5444783215232_4uEKOUP_tnpuwr.webp', name: 'Acer-Lenovo' },
  { id: 'OIP_ec7zrk.webp', name: 'Brand 1' },
  { id: 'mitsubishi-heavy-industries3114_l95zsv.jpg', name: 'Brand 2' },
  { id: 'Canon-Emblem_gscpxh.png', name: 'Brand 3' },
  { id: 'OIP_afzay4.webp', name: 'Brand 3' },
  { id: 'ao-smith1868.logowik.com_zgtogg.webp', name: 'Brand 4' },
  { id: 'Asus-Logo.wine_rvfop4.png', name: 'Brand 5' },
  { id: 'boat-logo-1536x864_a8qmft.jpg', name: 'Acer-Lenovo' }
];
